var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 2.3422C15.2376 1.62767 16.7624 1.62767 18 2.3422L26.6656 7.3453C27.9032 8.05983 28.6656 9.38034 28.6656 10.8094V20.8156C28.6656 22.2447 27.9032 23.5652 26.6656 24.2797L18 29.2828C16.7624 29.9973 15.2376 29.9973 14 29.2828L5.33438 24.2797C4.09677 23.5652 3.33438 22.2447 3.33438 20.8156V10.8094C3.33438 9.38034 4.09677 8.05983 5.33438 7.3453L14 2.3422Z",
    fill: "#E32E39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 2.3422C15.2376 1.62767 16.7624 1.62767 18 2.3422L26.6656 7.3453C27.9032 8.05983 28.6656 9.38034 28.6656 10.8094V20.8156C28.6656 22.2447 27.9032 23.5652 26.6656 24.2797L18 29.2828C16.7624 29.9973 15.2376 29.9973 14 29.2828L5.33438 24.2797C4.09677 23.5652 3.33438 22.2447 3.33438 20.8156V10.8094C3.33438 9.38034 4.09677 8.05983 5.33438 7.3453L14 2.3422Z",
    fill: "white",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 5.1547C15.2376 4.44017 16.7624 4.44017 18 5.1547L24.3923 8.8453C25.6299 9.55983 26.3923 10.8803 26.3923 12.3094V19.6906C26.3923 21.1197 25.6299 22.4402 24.3923 23.1547L18 26.8453C16.7624 27.5598 15.2376 27.5598 14 26.8453L7.6077 23.1547C6.37009 22.4402 5.6077 21.1197 5.6077 19.6906V12.3094C5.6077 10.8803 6.37009 9.55983 7.6077 8.8453L14 5.1547Z",
    fill: "#C12229"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1662 20.7083C12.3474 22.0208 14.1099 22.8083 16.0974 22.8083C19.1162 22.8083 21.0099 21.0646 21.0099 18.7115C21.0099 16.6115 19.6318 15.2333 16.8287 14.5865C15.1037 14.1927 14.5787 13.649 14.5787 12.9177C14.5787 12.2708 15.2162 11.8021 16.0412 11.8021C17.0068 11.8021 17.9255 12.3365 18.7599 13.0583L20.3349 10.9021C19.2099 9.87084 17.6537 9.23334 15.9099 9.23334C13.3037 9.23334 11.4474 10.9021 11.4474 13.1615C11.4474 15.1771 12.938 16.5365 15.4224 17.0708C17.4005 17.4927 17.8787 18.1208 17.8787 18.8615C17.8787 19.6583 17.0912 20.2021 16.088 20.2021C14.8974 20.2021 13.7162 19.5458 12.8349 18.6271L11.1662 20.7083Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 9.16614,
    y: 9.23334,
    width: 13.8438,
    height: 17.575,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpire);
export default __webpack_public_path__ + "static/media/Spire.4528feb42b4b3d4864f8e32832a45528.svg";
export { ForwardRef as ReactComponent };